enum ETimeframes {
    oneSecond = '1s',
    fiveSeconds = '5s',
    tenSeconds = '10s',
    minute = '1m',
    threeMinutes = '3m',
    fiveMinute = '5m',
    fifteenMinutes = '15m',
    thirtyMinutes = '30m',
    hour = '1h',
    twoHours = '2h',
    fourHours = '4h',
    sixHours = '6h',
    eightHours = '8h',
    twelveHours = '12h',
    day = '1D',
    threeDays = '3D',
    week = '1W',
    month = '1M',
    quarter = 'quarter',
    year = 'year',
  }

  export { ETimeframes }